export default {
    name: "Accordion",
    props: {
        productNumber: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup(){

        const toggleAccordion = function(e){
            const isExpanded = !!(e.currentTarget.getAttribute('aria-expanded') === 'true')
            const accordionTarget = document.querySelector('#'+e.currentTarget.getAttribute('aria-controls'))
            const chevronTarget = e.currentTarget.querySelector('.kb-accordion__question__chevron')

            chevronTarget.classList[isExpanded ? 'remove' : 'add']('kb-accordion__question__chevron--open')
            accordionTarget.classList[isExpanded ? 'remove' : 'add']('kb-accordion__answer--open')
            accordionTarget.setAttribute('aria-hidden',(isExpanded ? 'true' : 'false'))
            e.currentTarget.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')

            accordionTarget.querySelectorAll('a').forEach(a => {
                if (isExpanded) {
                    a.setAttribute("tabindex", -1)
                } else {
                    a.removeAttribute("tabindex")
                }
            });
        }

        return {
            toggleAccordion
        }
    }
}